import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { ConfirmationService, MessageService } from "primeng/api";
import { environment } from "src/environments/environment";
import { MyserviceService } from "../myservice.service";
@Component({
    selector: "app-user-search",
    templateUrl: "./user-search.component.html",
    styleUrls: ["./user-search.component.css"],
    providers: [ConfirmationService, MessageService]
})
export class UserSearchComponent implements OnInit {
    rowsNo = 0;
    offset:number = 0;
    pageSize:number = 10;
    noOfRecords: number=0;
    hasSearched=false;
    sortField: String;
    sortOrder: number = -1;
    loader:boolean;
    status = [];
    selectstatus: any;
    visibleSidebar2: boolean = false;
    display: boolean = false;
    display1: boolean;
    responseMsg: boolean = false;
    userRole: string;
    user: any = {};
    userSearchData: any = [];
    userAssignFlowData: any = {
        manufacturing: false,
        primaryFlowId: "",
        userName: "",
        loginId: "",
        roleId: "",
        userId: "",
        webForms : "",
        tpm: "",
        mscvp: "",
        userType : "",
    };
    PRIMARY_FLOWS: any = [];
    ROLES: any = [];
    checkMe = "";
    userAssignFlowResultMessage = "";
    userUpdateResultMessage = "";
    checked: boolean = false;
    assignFlowResponseViewTime: boolean = false;
    userUpdateResponseViewTime: boolean = false;
    ackStatusArray = [];
    statusArray = [];
    primaryFlowArray = [];
    applicationsList =[
        {label:"MSCVP", value:'true'},
        {label:"TPM", value:'true'},
        {label:"WebForms", value:'true'},
    ]
    partnerNameList = [
        { label: "Select", value: ''},
        { label: "Walmart", value: "walmart123" },
        { label: "Amazon", value: "amazon123" },
      ]
      partnerName:{ label: '', value: '' };

      userTypeList =[
        { label: "Select", value: ''},
        { label: "Admin", value: "admin" },
        { label: "Internal", value: "internal" },
        { label: "External", value: "external" },
      ]
    departmentArray = [];
    rolesArray = [];
    partnerData: any=[];
    sfgPartnerData:any=[];
    userUpdateForm: any;
    userData: any;
    isSuperUser: boolean;
    showB2BPart: boolean;
    showSfgPart: boolean;
    filteredData: any=[];
    sfgFilteredData: any=[];
    previewOptions: any = [{ key: '-1', label: "Select" }, { key: false, label: "No" }, { key: true, label: "Yes" }]
    tableHeaders: any;
    timeZones: any=[];
    isProd:boolean=environment.prod;
    enableFields: boolean =false;
    departmentOptions = [];
    partnersList: any = [];
    constructor(
        private myservice: MyserviceService,
        public session: SessionStorageService,
        public localstorage: LocalStorageService,
        private http: HttpClient,
        private fb: FormBuilder,
        private confirmationService: ConfirmationService,
        private messageService: MessageService
    ) {}

    ngOnInit() {
        this.getTimeZones();
        this.getPartnersLookupData();
        this.getSfgPartnersLookupData();
        this.getAllPartners();
        this.userRole = this.session.retrieve("userRole");
        this.rolesArray.push({ label: "Select", value: -1 });
        this.rolesArray = this.myservice.getMscvpRoles(
            this.localstorage.retrieve("token")
        );

        this.departmentArray.push({
            label: "Select",
            value: -1,
        });
        this.departmentArray.push({ label: "Management", value: 1 });
        this.departmentArray.push({ label: "Operations", value: 2 });
        this.departmentArray.push({ label: "Development", value: 3 });

        this.status.push({
            label: "Select",
            value: "-1",
        });
        this.status.push({ label: "ACTIVE", value: "A" });
        this.status.push({ label: "INACTIVE", value: "I" });
        this.status.push({ label: "TERMINATED", value: "T" });
        this.status.push({ label: "REGISTERED", value: "R" });

        this.departmentOptions.push({
            label: "Select",
            value: "-1",
        });
        this.departmentOptions.push({ label: "Management", value: "1" });
        this.departmentOptions.push({ label: "Operations", value: "2" });
        this.departmentOptions.push({ label: "Development", value: "3" });
        
        this.userAssignFlowData.primaryFlowId = "";
        this.user.firstName = "";
        this.user.lastName = "";
        this.user.loginId = "";
        this.user.status = "-1";
        this.userAssignFlowData = [];
        this.tableHeaders = [
            { field: "", header: "Assign flow", width: "3%" },
            { field: "loginId", header: "Login Id", width: "5%" },
            { field: "userName", header: "Name", width: "6%" },
            { field: "email", header: "Email", width: "7%" },
            { field: "officePhone", header: "Office Phone", width: "4%" },
            { field: "status", header: "Status", width: "3%" },
            { field: "", header: "Delete Account", width: "3%" },
        ];
        this.userUpdateForm = this.fb.group({
            firstName: new FormControl("", Validators.required),
            lastName: new FormControl("", Validators.required),
            email: new FormControl("", [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),            
            officePhone: new FormControl("", Validators.required),
            timeZone: new FormControl("", Validators.required),
            status: new FormControl("", Validators.required),
            roleId: new FormControl("", Validators.required),
            departmentId: new FormControl("", Validators.required),
            partnerIds: new FormControl([]),
            sfgPartnersNames:new FormControl([]),
            fileVisibility: new FormControl({key: false, label: 'No'},Validators.required),
        });
        //Add partner access functionality is limited upto QA environment
        if (!this.isProd) {
            this.userUpdateForm.addControl('addPartnersAccess', new FormControl({ key: false, label: 'No' }, Validators.required));
        }
    }
 //To get list of timezones and patch est as default value
 getTimeZones() {
    this.myservice.getTimeZones(this.localstorage.retrieve("token")).subscribe((res) => {
        this.timeZones = res;
        this.userUpdateForm.controls["timeZone"].patchValue(this.timeZones.filter((res) => res.id == "est")[0])
    })
}
    onSelectType(event) {
        if (event) {
            this.selectstatus = event;
        }
    }
    //For server side pagination and sorting
    onPagination(data) {
        this.rowsNo = data.first + data.rows >= this.noOfRecords ? this.noOfRecords : data.first + data.rows;
        //Checking if the previous pagination and sorting fields are different with latest fields or not to reduce the API hits
        if (data.first != this.offset || data.rows != this.pageSize || data.sortField != this.sortField || data.sortOrder != this.sortOrder) {
            this.offset = data.first;
            this.pageSize = data.rows;
            this.sortField = data.sortField;
            this.sortOrder = data.sortOrder;
            this.search();
        }
    }

    search(countFlag=false) {
        this.hasSearched=true;
        this.userSearchData = [];
        this.loader=true;
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        let reqPayload={...this.user}
        reqPayload.limit=this.pageSize;
        reqPayload.offSet=this.offset;
        reqPayload.sortField=this.sortField==undefined ?"":this.sortField;
        reqPayload.sortOrder= this.sortOrder == 1 ? "ASC" : "DESC";
        this.http
            .post(environment.apiUrl + "/user/search", {...reqPayload,countFlag}, {
                headers: headers,
            })
            .subscribe((res:any) => {
                this.userSearchData = res.data;
                if (countFlag) {
                    this.noOfRecords = res.totalRecordsCount;
                }
                this.loader=false;
            });
    }

    getUserFlows(userId) {
        this.display = true;
        this.userAssignFlowData = [];
        this.primaryFlowArray.push({ label: "Select", value: "0" });
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.primaryFlowArray = this.myservice.getprimaryFlows(
            this.localstorage.retrieve("token")
        );
        this.http
            .get(environment.apiUrl + "/user/assignFlowinfo/" + userId, {
                headers: headers,
            })
            .subscribe((data:any) => {
                //console.log(data,"user data");         
                data.webForms = data.webForms === "true" ? true : false
                data.tpm = data.tpm === "true" ? true : false,
                data.mscvp = data.mscvp === "true" ? true : false 
            //   this.partnersList.find((item: any) => item.label === data.partnerName);
                // reqBody.partnerId = selectedPartner ? selectedPartner.value : '';
                if (data.partnerName) {
                    const partner = this.partnersList.find((x: any) => x.label === data.partnerName);
                    if (partner) {
                        data.partnerName = partner;
                    }
                }
            //    if(data.timeZone){
            //     // this.userUpdateForm.controls["timeZone"].patchValue(this.timeZones.filter((res)=>res.id=="est")[0])
            //     let selectedTimeZone = this.timeZones.filter((zone)=>zone.id == data.timeZone)[0];  
            //     if(selectedTimeZone) {
            //         data.timeZone = selectedTimeZone;
            //     }
            //    }

                // this.partnerName   = data.partnerName
                this.userAssignFlowData = data;                
                this.visibleSidebar2 = true;
                // //console.log(this.partnersList.filter((x:any) => x.label === data.partnerId)[0], "===")
            });
    }

    closeAssignFlow() {
        this.userAssignFlowData = [];
    }
    setPartners(data){
        let bothRoles=[1,6,7];
        let partRoles=[1,2,3,6,7];
        let sfgPartRoles=[1,4,5,6,7];
        if(data=="1"){
            this.isSuperUser=true;
            this.userUpdateForm.patchValue({partnerIds: this.partnerData})
            this.userUpdateForm.get("fileVisibility").patchValue({ key: true, label: "Yes" });
            !this.isProd&&this.userUpdateForm.get("addPartnersAccess").patchValue({ key: true, label: "Yes" });
            this.userUpdateForm.patchValue({sfgPartnersNames: this.sfgPartnerData})
        }
        else{
            this.isSuperUser=false;
            this.userUpdateForm.patchValue({partnerIds: this.filteredData})
             this.userUpdateForm.patchValue({sfgPartnersNames: this.sfgFilteredData})
             this.userUpdateForm.get("fileVisibility").patchValue({ key: false, label: "No" });
             !this.isProd&&this.userUpdateForm.get("addPartnersAccess").patchValue({ key: false, label: "No" });
            }
              //To show partner visibility dropdown and set validators
        if (bothRoles.includes(data)) {
            this.showB2BPart=true;
            this.showSfgPart=true;
            this.userUpdateForm.get("partnerIds").setValidators([Validators.required])
            this.userUpdateForm.get("sfgPartnersNames").setValidators([Validators.required])
        } else if(partRoles.includes(data)) {
            this.showB2BPart=true;
            this.showSfgPart=false;  
            this.userUpdateForm.patchValue({sfgPartnersNames: []})
            this.userUpdateForm.get("partnerIds").setValidators([Validators.required])
            this.userUpdateForm.get("sfgPartnersNames").setValidators([]) 
        }
        else if (sfgPartRoles.includes(data)){
            this.showB2BPart=false;
            this.showSfgPart=true;  
            this.userUpdateForm.patchValue({partnerIds: []})
            this.userUpdateForm.get("partnerIds").setValidators([])
            this.userUpdateForm.get("sfgPartnersNames").setValidators([Validators.required]) 
        }
        this.userUpdateForm.get("partnerIds").updateValueAndValidity()
        this.userUpdateForm.get("sfgPartnersNames").updateValueAndValidity() 
    }
    // assignUserFlows(userAssignFlowData) {
    //     if (!userAssignFlowData.roleId || userAssignFlowData.userType === '-' || !userAssignFlowData.partnerName || 
    //         (!userAssignFlowData.webForms && !userAssignFlowData.tpm && !userAssignFlowData.mscvp)) {
    //         // //console.error("Validation failed: Role, User Type, Partner Name, and at least one Application Access are required.");
    //         this.messageService.add({
    //             severity: "error",
    //             summary: "Error",
    //             detail: "Validation Failed",
    //         });
    //         return;
    //     }        
    //    else{
    //     let reqBody={...userAssignFlowData};        
    //     if(reqBody.partnerName){
    //     const selectedPartner = this.partnersList.find((item: any) => item.label === reqBody.partnerName);
    //      reqBody.partnerId = selectedPartner ? selectedPartner.value : '';
    //     }
    //     //console.log(userAssignFlowData,reqBody ,"======roleeee");
    //     let headers = new HttpHeaders();
    //     headers = headers.append(
    //         "authorization",
    //         this.localstorage.retrieve("token")
    //     );
    //     this.http
    //         .post(environment.apiUrl + "/user/assignFlow", reqBody, {
    //             headers: headers,
    //             responseType: "text",
    //         })
    //         .subscribe((data) => {                
    //             this.userAssignFlowResultMessage = data;
    //             this.assignFlowResponseViewTime = true;
    //             setTimeout(
    //                 function () {
    //                     this.assignFlowResponseViewTime = false;
    //                 }.bind(this),
    //                 2000
    //             );
    //             if(data === "Partner updated succesfully."){
    //                 this.display = false
    //                 this.messageService.add({
    //                     severity: "success",
    //                     summary: "Success",
    //                     detail: "Assigned Successfully.",
    //                   });
    //                 }
    //                 else{
    //                     this.messageService.add({
    //                         severity: "error",
    //                         summary: "Error",
    //                         detail: "Update Failed",
    //                       });
    //                 }
    //         });
    //     }
    // }
    
    assignUserFlows(userAssignFlowData) {
        
        // Check if required fields are empty
        // || userAssignFlowData.timeZone === '-'
        if (!userAssignFlowData.roleId || userAssignFlowData.userType === '-' || 
            (!userAssignFlowData.webForms && !userAssignFlowData.tpm && !userAssignFlowData.mscvp)) {
            //console.error("Validation failed: Role, User Type, Partner Name, and at least one Application Access are required.");
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Validation Failed",
            });
            return; // Exit the function if validation fails
        }
    
        // Additional check if webForms is selected but partnerName is not provided
        if (userAssignFlowData.webForms && !userAssignFlowData.partnerName && !userAssignFlowData.partnerId) {
            //console.error("Validation failed: Partner Name is required when WebForms is selected.");
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Partner Name is required when WebForms is selected.",
            });
            return; // Exit the function if validation fails
        }
    
        // Prepare request body
        let reqBody = { ...userAssignFlowData };
        reqBody.active = "A",
        // reqBody.roleName = reqBody.roleName ? reqBody.roleName.label : ''; 
        reqBody.partnerName = reqBody.partnerName ? reqBody.partnerName.label : '';   
        if(reqBody.roleId){
            const selectedRole = this.rolesArray.find((item: any) => item.value === reqBody.roleId);
            reqBody.roleName = selectedRole ? selectedRole.label : '';
        }     
        // if(reqBody.timeZone)   {
        //     reqBody.timeZone =  reqBody.timeZone ?  reqBody.timeZone.id : '';
        // }
        if (reqBody.partnerName){
            const selectedPartner = this.partnersList.find((item: any) => item.label === reqBody.partnerName);
            reqBody.partnerId = selectedPartner ? selectedPartner.value : '';
        }   
        //console.log(userAssignFlowData, reqBody, "======roleeee");
        let headers = new HttpHeaders();
        headers = headers.append("authorization", this.localstorage.retrieve("token"));
    
        // Make the API call
        this.http.post(environment.apiUrl + "/user/assignFlow", reqBody, {
            headers: headers,
            responseType: "text",
        }).subscribe((data) => {                
            this.userAssignFlowResultMessage = data;
            this.assignFlowResponseViewTime = true;
            setTimeout(() => {
                this.assignFlowResponseViewTime = false;
            }, 2000);
    
            if (data === "Partner updated succesfully.") {
                this.display = false;
                this.enableFields = false;
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Assigned Successfully.",
                });
            } else {
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Update Failed",
                });
            }
        });
    }

    userInfoUpdate() {
        let selectedPartners=[]
        let selectedSfgPartners=[]
        this.userUpdateForm.value.partnerIds.forEach(element => {
            selectedPartners.push(element.value)
        }); 
        this.userUpdateForm.value.sfgPartnersNames.forEach(element => {
            selectedSfgPartners.push(element.label)
        });
        selectedPartners=this.partnerData.length===selectedPartners.length?["ALL"]:selectedPartners;
        selectedSfgPartners=this.sfgPartnerData.length===selectedSfgPartners.length?["ALL"]:selectedSfgPartners;
        this.session.retrieve("UserDetails").loginId;
        let timeZone=this.userUpdateForm.value.timeZone.id;
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        ); 
        let reqBody={...this.userUpdateForm.value,partnerIds:selectedPartners,userId:this.userData.userId,
            createdBy:this.userData.createdBy,sfgPartnersNames:selectedSfgPartners,fileVisibility:this.userUpdateForm.value.fileVisibility.key,"timeZone":timeZone}
        if (!this.isProd) {
            reqBody["addPartnersAccess"] = this.userUpdateForm.value.addPartnersAccess.key
        }
        this.http
            .post(environment.apiUrl + "/user/updateUser", reqBody, {
                headers: headers,
                responseType: "text",
            })
            .subscribe((data) => {
                this.userUpdateResultMessage = data;
                this.responseMsg = true;

                setTimeout(
                    function () {
                        this.responseMsg = false;
                    }.bind(this),
                    2000
                );

                this.search();
            });
    }
    userInfo(userId) {
        this.display1 = true;

        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .get(environment.apiUrl + "/user/info/" + userId, {
                headers: headers,
            })
            .subscribe((data) => {
                 this.userData = data;
                 //console.log(data,"====userdataa")
                 this.isSuperUser=this.userData.roleId==1;
                 this.patchData(this.userData);
            });
    }
    patchData(data) {
        this.filteredData = []
        this.sfgFilteredData=[]
        if (data.partnerIds[0]=="ALL") {
            this.filteredData.push(...this.partnerData)
        } else {
            data.partnerIds.forEach(element => {
                this.filteredData.push(...this.partnerData.filter((res) => { return res.value === element }))
            });  
        } 
        if (data.sfgPartnersNames[0]=="ALL") {
            this.sfgFilteredData.push(...this.sfgPartnerData)
        } else {
            data.sfgPartnersNames.forEach(element => {
                this.sfgFilteredData.push(...this.sfgPartnerData.filter((res) => { return res.label === element }))
            });  
        }
        let selectedTimeZone=this.timeZones.filter((zone)=>zone.id==data.timeZone)[0];
        this.setPartners(data.roleId)
        this.userUpdateForm.patchValue({
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            officePhone: data.officePhone,
            status: data.status,
            roleId: parseInt(data.roleId),
            departmentId: data.departmentId,
            partnerIds: this.filteredData,
            sfgPartnersNames:this.sfgFilteredData,
            fileVisibility:this.previewOptions.filter((res)=>res.key==data.fileVisibility)[0],
            timeZone:selectedTimeZone,
        })
        if (!this.isProd) {
            this.userUpdateForm.patchValue({
            addPartnersAccess:this.previewOptions.filter((res)=>res.key==data.addPartnersAccess)[0]
        })
        }
    }
    closeUserInfo() {
        this.userUpdateForm.reset()
    }
    setDefaultPagination(){
        this.hasSearched = false;
        this.offset = 0;
        this.pageSize = 10;
        this.noOfRecords = 0;
        this.sortField = undefined;
        this.sortOrder = -1;
    }

    reset() {
        this.setDefaultPagination();
        this.userSearchData = [];
        this.userAssignFlowData = [];
        this.userUpdateForm.reset()
        this.user.firstName = "";
        this.user.lastName = "";
        this.user.loginId = "";
        this.user.status = "-1";
        this.userAssignFlowData.primaryFlowId = "";
        this.userUpdateForm.controls["timeZone"].patchValue(this.timeZones.filter((res)=>res.id=="est")[0])
    }
    getPartnersLookupData() {
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .get(environment.apiUrl + "/partner/all", { headers: headers })
            .subscribe(
                (data: any) => {
                    this.partnerData=data;
                    this.partnerData=this.partnerData.filter((data)=>{return !environment.amcPartnerIds.includes(data.value)});
                 this.partnerData=this.partnerData.map(element=>({...element,optionLabel:`${element.label}(${element.value})`}))
                },
                (err) => {
                    //console.log(err, err.statusText, "error");
                }
            )
    }
    getSfgPartnersLookupData() {
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
        .get(environment.apiUrl + "/sfg/partnerVisibility", { headers: headers })
        .subscribe(
            (data: any) => {
                let keys = Object.keys(data);
                for (var i = 0; i < keys.length; i++) {
                    this.sfgPartnerData.push({
                        label: data[keys[i]],
                    });
                }
            },
            (err) => {
                //console.log(err, err.statusText, "error");
            }
        )
    }
    deleteAccount(id,name) {
        this.confirmationService.confirm({
            message: `Are you sure that you want to delete <b>${name}</b>'s account?`,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            key: "positionDialog",
            accept: () => {
                this.loader = true;
                let headers = new HttpHeaders();
                headers = headers.append(
                    "authorization",
                    this.localstorage.retrieve("token")
                );
                this.http.post(environment.apiUrl + "/user/deleteUser/" + id, {}, { headers: headers, responseType: "text" })
                    .subscribe((data) => {
                        this.loader = false;
                        if (data == "User deleted successfully") {
                            this.setDefaultPagination();
                            this.search(true);
                            this.messageService.add({
                                severity: "success",
                                detail: data,
                            });
                        } else {
                            this.messageService.add({
                                severity: "error",
                                detail: data,
                            });
                        }
                    });
            },
            reject: () => {
            }
        });
    }
      onChangeAppAccess(eve: any, type: string) {
        //console.log(eve, type);
        if (eve) {
          this.enableFields = true;  
        } else {
          this.enableFields = false;  
        }
      }

      getAllPartners(){
        let headers = new HttpHeaders();
        headers = headers.append("authorization", this.localstorage.retrieve("token"));
        this.http.get(environment.apiUrl + "/utilities/PartnersIdAndName", { headers: headers })
            .subscribe((response: any) => {
                if (!response || response.length === 0) {
                    this.partnersList = [];
                    return;
                }    
                this.partnersList = [{ label: "Select", value: "" }, ...response.map(item => ({
                    label: item.TC_PartnerName,  // Display name
                    value: item.TC_PARTNER_ISA_ID // Actual stored value
                }))];
                //console.log("Fetched Partners:", this.partnersList);
            }, error => {
                //console.error("Error fetching partners:", error);
            });
      }
}
